import { useMatch, useNavigate } from 'react-router-dom';
import React from 'react';
import CountryPage from '../../pages/CountryPage'; // Adjust the import path as necessary

const CustomRouteCountry: React.FC = () => {
  const match = useMatch('/destinations/:slug');
  const navigate = useNavigate();

  if (!match) {
    return null;
  }

  const { slug } = match.params as { slug: string };

  if (!slug) {
    navigate('/404'); // Redirect to a 404 page if the URL is not correctly formatted
    return null;
  }

  return <CountryPage slug={slug} />;
};

export default CustomRouteCountry;
